import { render, staticRenderFns } from "./UserClientEdit.vue?vue&type=template&id=ceb04876&scoped=true&"
import script from "./UserClientEdit.vue?vue&type=script&lang=js&"
export * from "./UserClientEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserClientEdit.vue?vue&type=style&index=0&id=ceb04876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb04876",
  null
  
)

export default component.exports